package pl.finn.forms.podpp

import io.kvision.core.*
import io.kvision.form.*
import io.kvision.form.check.CheckBox
import io.kvision.form.check.RadioGroup
import io.kvision.form.select.selectOption
import io.kvision.html.*
import io.kvision.modal.Alert
import io.kvision.modal.Confirm
import io.kvision.panel.SimplePanel
import io.kvision.state.bind
import io.kvision.utils.px
import pl.finn.forms.POLE_WYMAGANE
import pl.finn.forms.podpp.Model.formularzStore

import io.kvision.form.select.Select
import io.kvision.form.text.Text
import io.kvision.form.text.TextArea
import io.kvision.form.text.TomTypeahead
import io.kvision.form.text.textInput
import io.kvision.form.upload.uploadInput
import io.kvision.panel.FieldsetPanel
import io.kvision.panel.hPanel
import io.kvision.table.*
import pl.finn.forms.fk02.DynamicFieldsValidator
import pl.finn.forms.utils.model.Util

class PodppPanel : SimplePanel() {

  private val dynamicFieldsValidator = DynamicFieldsValidator()
//  val rozszerzeniaZalacznikow = setOf(
//    "7z", "avi", "CAdES", "css", "csv", "dgn", "doc",
//    "docx", "dwf", "dwg", "dxf", "geotiff", "gif", "gml", "gz", "gzip", "html",
//    "jp2", "jpeg", "jpg", "m4a", "mp3", "mp4", "mpeg", "mpeg4", "mpg", "odp", "ods",
//    "odt", "ogg", "ogv", "ott", "PAdES", "pdf", "png", "ppt", "pptx", "rng", "rtf",
//    "svg", "tar", "tif", "tiff", "tls", "txt", "wav", "XAdES", "xhtml", "xls",
//    "xlsx", "xml", "XMLenc", "XMLsig", "xps", "xsd", "xsl", "xslt", "zip"
//  ) // Util.rozszerzeniaZalacznikow

  init {
    bind(formularzStore)
    { state ->
      main {
        margin = 15.px
        id = "peupcontent"
        state.bladZapisu?.let {
          div(it, className = "alert alert-danger") {
            role = "alert"
          }
        }
        when (state.widok) {
          FormularzWidok.EDYCJA, FormularzWidok.NOWY -> {
            if (state.form != null) {
              val formPanel = formPanel<PodppForm>(
                type = FormType.HORIZONTAL, horizRatio = FormHorizontalRatio.RATIO_2, className = "mx-2 mx-md-5 mt-3",
                condensed = true
              ) {
                add(createButtonPanel(state, this@formPanel))
                h1(
                  "Pismo ogólne do podmiotu publicznego", //tytuł
                  className = "h4 text-center"
                ) {
                  tabindex = -1
                }
                //place for fields [start]

                var innyRodzaj =
                  Text(
                    value = state.form.innyRodzaj,
                    label = "Inny rodzaj pisma"
                  ).apply {
                    placeholder = "Wpisz rodzaj pisma"
                    visible = state.form.rodzaj == "inne pismo"
                    onEvent {
                      change = {
                        state.form.innyRodzaj = self.value
                      }
                    }
                    styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                    flabel.addCssClass("required-label")
                  }

                add(
                  dynamicFieldsValidator.add(
                    Select(
                      value = state.form.rodzaj,
                      label = "Rodzaj pisma"
                    ).apply {
                      placeholder = "Wybierz rodzaj pisma"
                      emptyOption = true
                      onEvent {
                        change = {
                          state.form.rodzaj = self.value
                          if (self.value == "inne pismo") {
                            innyRodzaj.show()
                          } else {
                            innyRodzaj.hide()
                          }
                        }
                      }
                      for ((key, value) in PodppData.documentTypeMap) {
                        selectOption(value = key,label = value)
                        liveSearch = true
                      }
                    },
                    { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
                    POLE_WYMAGANE
                  )
                )
                add(
                  dynamicFieldsValidator.add(
                    innyRodzaj,
                    { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!innyRodzaj.visible) ) },
                    POLE_WYMAGANE
                  )
                )

                add(
                  dynamicFieldsValidator.add(
                    Text(
                      value = state.form.tytul,
                      label = "Tytuł pisma"
                    ).apply {
                      placeholder = "Wpisz tytuł pisma"
                      onEvent {
                        change = {
                          state.form.tytul = self.value
                        }
                      }
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                      flabel.addCssClass("required-label")
                    },
                    { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
                    POLE_WYMAGANE
                  )
                )
                add(
                  dynamicFieldsValidator.add(
                    TextArea(
                      value = state.form.tresc,
                      label = "Treść pisma", rows = 10
                    ).apply {
                      placeholder = "Wpisz treść pisma"
                      onEvent {
                        change = {
                          state.form.tresc = self.value
                        }
                      }
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                      flabel.addCssClass("required-label")
                    },
                    { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
                    POLE_WYMAGANE
                  )
                )

                var informacjeDodatkowe = createAddictionalInformations(state, this)
                add(
                  FieldsetPanel().apply {
                    add(
                      CheckBox(
                        value = state.form.posiadaInformacjeDodatkowe,
                        label = "Informacje dodatkowe",
                        rich = true
                      ).apply {
                        onEvent {
                          change = {
                            state.form.posiadaInformacjeDodatkowe = self.value
                            if (self.value) {
                              informacjeDodatkowe.show()
                              dynamicFieldsValidator.removeNotValidationGroup("informacjeDodatkowe")
                            } else {
                              informacjeDodatkowe.hide()
                              dynamicFieldsValidator.addNotValidationGroup("informacjeDodatkowe")
                            }
                          }
                        }
                      }
                    )
                    add(informacjeDodatkowe)
                  }
                )

                var doWiadomosci = createCarbonCopyList(state, this)
                add(
                  FieldsetPanel().apply {
                    add(
                      CheckBox(
                        value = state.form.posiadaDoWiadomosci,
                        label = "Do Wiadomosci",
                        rich = true
                      ).apply {
                        onEvent {
                          change = {
                            state.form.posiadaDoWiadomosci = self.value
                            if (self.value) {
                              doWiadomosci.show()
                              dynamicFieldsValidator.removeNotValidationGroup("doWiadomosci")
                            } else {
                              doWiadomosci.hide()
                              dynamicFieldsValidator.addNotValidationGroup("doWiadomosci")
                            }
                          }
                        }
                      }
                    )
                    add(doWiadomosci)
                  }
                )
                div("Załączniki do pisma")
                if (!state.zalaczniki.isNullOrEmpty()) {
                  table(
                    listOf("Nazwa pliku", "Opis załącznika", ""),
                    setOf(TableType.HOVER, TableType.STRIPED, TableType.BORDERED, TableType.SMALL),
                    "Lista załączników do pisma",
                    responsiveType = ResponsiveType.RESPONSIVE
                  ) {
                    state.zalaczniki.forEach { zalacznik ->
                      row {
                        cell {
                          verticalAlign = VerticalAlign.MIDDLE
                          b(zalacznik.nazwa)
                        }
                        cell {
                          verticalAlign = VerticalAlign.MIDDLE
                          zalacznik.opis?.let {
                            div(it)
                          }
                        }
                        cell {
                          align = Align.CENTER
                          width = 150.px
                          button("Usuń załącznik", "fas fa-trash", ButtonStyle.DANGER) {
                            size = ButtonSize.SMALL
                            onClick {
                              Model.usunZalacznik(
                                zalacznik.nazwa,
                                state.form
                              )
                            }
                          }
                        }
                      }
                    }
                  }
                }
                hPanel(spacing = 10, wrap = FlexWrap.WRAP, className = "wrap-panel") {
                  val zalacznik = uploadInput("/") {
                    explorerTheme = true
                    showUpload = false
                    showCancel = false
                    showPreview = false
                    dropZoneEnabled = false
                    allowedFileExtensions = Util.rozszerzeniaZalacznikow
                  }
                  val opisZalacznika = textInput {
                    width = 300.px
                    placeholder = "Wprowadź opis załącznika"
                  }
                  button("Dodaj", "fas fa-upload").onClick {
                    Model.dodajZalacznik(
                      zalacznik,
                      opisZalacznika.value,
                      state.form
                    )
                  }
                }
                tag(
                  TAG.SMALL,
                  "Dozwolone rozszerzenia plików to: ${
                    Util.rozszerzeniaZalacznikow.map { ".$it" }
                      .joinToString()
                  }."
                )

                //place for fields [end]
              }
            }
          }
          else -> {}
        }
      }

    }

  }

  private fun createAddictionalInformations(state: Formularz, formPanel: FormPanel<PodppForm>): FieldsetPanel {
    val div = FieldsetPanel()

    if (state.form?.informacjeDodatkowe != null) {
      if (state.form.informacjeDodatkowe.isEmpty()) {
        state.form.informacjeDodatkowe.add(InformacjaDodatkowa(""))
      }
      if (!state.form.posiadaInformacjeDodatkowe) {
        dynamicFieldsValidator.addNotValidationGroup("informacjeDodatkowe")
      }
      div.apply {
        visible = state.form.posiadaInformacjeDodatkowe
        state.form.informacjeDodatkowe.forEach { informacjaDodatkowa ->
          add(
            dynamicFieldsValidator.add(
              Text(value = informacjaDodatkowa.informacjaDodatkowa, label = "Informacja").apply {
                onEvent {
                  change = {
                    informacjaDodatkowa.informacjaDodatkowa = self.value
                  }
                }
                styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                flabel.addCssClass("required-label")
              },
              { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
              POLE_WYMAGANE,
              "informacjeDodatkowe"
            )
          )
        }
      }
    }
    div.addAll(createAddictionalInformationsButtons(state, div).getChildren())
    return div
  }

  private fun createAddictionalInformationsButtons(state: Formularz, div: FieldsetPanel): Div {
    return Div(className = "p-2 d-flow-root") {
      button(
        "Usuń",
        "far fa-minus-square",
        ButtonStyle.OUTLINEPRIMARY, className = "btn-sm"
      ).apply {
        visible = state.form?.informacjeDodatkowe != null && state.form.informacjeDodatkowe.size > 1
      }.onClick {
        if (state.form?.informacjeDodatkowe != null && state.form.informacjeDodatkowe.size > 1) {
          state.form.informacjeDodatkowe.removeLast()
          dynamicFieldsValidator.removeAll(div.getChildren() as List<FormControl>)
          div.removeAll()
          div.apply {
            state.form.informacjeDodatkowe.forEach { informacjaDodatkowa ->
              add(
                dynamicFieldsValidator.add(
                  Text(value = informacjaDodatkowa.informacjaDodatkowa, label = "Informacja dodatkowa").apply {
                    onEvent {
                      change = {
                        informacjaDodatkowa.informacjaDodatkowa = self.value
                      }
                    }
                    styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                    flabel.addCssClass("required-label")
                  },
                  { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
                  POLE_WYMAGANE,
                  "informacjeDodatkowe"
                )
              )
            }
          }
          div.addAll(createAddictionalInformationsButtons(state, div).getChildren())
        }
      }
      button(
        "Dodaj",
        "far fa-plus-square",
        ButtonStyle.OUTLINEPRIMARY, className = "btn-sm float-right"
      ).onClick {
        if (state.form?.informacjeDodatkowe != null) {
          state.form.informacjeDodatkowe.add(InformacjaDodatkowa(""))
          dynamicFieldsValidator.removeAll(div.getChildren() as List<FormControl>)
          div.removeAll()
          div.apply {
            state.form.informacjeDodatkowe.forEach { informacjaDodatkowa ->
              add(
                dynamicFieldsValidator.add(
                  Text(value = informacjaDodatkowa.informacjaDodatkowa, label = "Informacja dodatkowa").apply {
                    onEvent {
                      change = {
                        informacjaDodatkowa.informacjaDodatkowa = self.value
                      }
                    }
                    styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                    flabel.addCssClass("required-label")
                  },
                  { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
                  POLE_WYMAGANE,
                  "informacjeDodatkowe"
                )
              )
            }
          }
          div.addAll(createAddictionalInformationsButtons(state, div).getChildren())
        }
      }
    }
  }

  private fun createCarbonCopyList(state: Formularz, formPanel: FormPanel<PodppForm>): Div {
    val div = Div()

    if (state.form?.doWiadomosci != null) {
      if (state.form.doWiadomosci.isEmpty()) {
        state.form.doWiadomosci.add(Podmiot())
      }
      if (!state.form.posiadaDoWiadomosci) {
        dynamicFieldsValidator.addNotValidationGroup("doWiadomosci")
      }
      div.apply {
        visible = state.form.posiadaDoWiadomosci
        state.form.doWiadomosci.forEach {
          add(
            createCarbonCopyElement(it)
          )
        }
      }
    }
    div.addAll(createCarbonCopyListButtons(state, div).getChildren())
    return div
  }

  private fun createCarbonCopyListButtons(state: Formularz, div: Div): Div {
    return (
      Div(className = "p-2 d-flow-root") {
        button(
          "Usuń",
          "far fa-minus-square",
          ButtonStyle.OUTLINEPRIMARY, className = "btn-sm"
        ).apply {
          visible = state.form?.doWiadomosci != null && state.form.doWiadomosci.size > 1
        }.onClick {

          if (state.form?.doWiadomosci != null && state.form.doWiadomosci.size > 1) {
            state.form.doWiadomosci.removeLast()
            dynamicFieldsValidator.removeAll(div.getChildren() as List<FormControl>)
            div.removeAll()
            div.apply {
              state.form.doWiadomosci.forEach {
                add(
                  createCarbonCopyElement(it)
                )
              }
            }
            div.addAll(createCarbonCopyListButtons(state, div).getChildren())
          }

        }
        button(
          "Dodaj",
          "far fa-plus-square",
          ButtonStyle.OUTLINEPRIMARY, className = "btn-sm float-right"
        ).onClick {

          if (state.form?.doWiadomosci != null) {
            state.form.doWiadomosci.add(Podmiot())
            dynamicFieldsValidator.removeAll(div.getChildren() as List<FormControl>)
            div.removeAll()
            div.apply {
              state.form.doWiadomosci.forEach {
                add(
                  createCarbonCopyElement(it)
                )
              }
            }
            div.addAll(createCarbonCopyListButtons(state, div).getChildren())
          }

        }
      }
      )
  }

  private fun createCarbonCopyElement(podmiot: Podmiot): FieldsetPanel {
    return FieldsetPanel().apply {
      val instytucja = createInstitutionElement(podmiot.instytucja, podmiot.jestInstytucja)//: FieldsetPanel
      val osoba = createPersonElement(podmiot.osoba, podmiot.jestInstytucja)//: FieldsetPanel
      add(
        dynamicFieldsValidator.add(
          RadioGroup(
            listOf("0" to "Osoba", "1" to "Instytucja"),
            value = podmiot.jestInstytucja,
            label = "Podmiot", inline = true
          ).apply {
            onEvent {
              change = {
                podmiot.jestInstytucja = self.value
                if (self.value == "0") {
                  instytucja.hide()
                  osoba.show()
                } else {
                  instytucja.show()
                  osoba.hide()
                }
              }
            }
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
          POLE_WYMAGANE,
          "doWiadomosci"
        )
      )
      add(osoba)
      add(instytucja)
    }
  }



  private fun createInstitutionElement(instytucja: Instytucja, jestInstytucja: String?): FieldsetPanel {
    return FieldsetPanel().apply {
      visible = jestInstytucja != null && jestInstytucja == "1"
      add(
        dynamicFieldsValidator.add(
          Text(
            value = instytucja.nazwaInstytucji,
            label = "Nazwa Instytucji"
          ).apply {
            onEvent {
              change = {
                instytucja.nazwaInstytucji = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
            flabel.addCssClass("required-label")
          },
          { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
          POLE_WYMAGANE,
          "doWiadomosci"
        )
      )
      add(createAddressElement(instytucja.adres))
    }
  }

  private fun createPersonElement(osoba: Osoba, jestInstytucja: String?): FieldsetPanel {
    return FieldsetPanel().apply {
      visible = jestInstytucja != null && jestInstytucja == "0"
      add(
        dynamicFieldsValidator.add(
          Text(
            value = osoba.imie,
            label = "Imię"
          ).apply {
            onEvent {
              change = {
                osoba.imie = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
            flabel.addCssClass("required-label")
          },
          { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
          POLE_WYMAGANE,
          "doWiadomosci"
        )
      )
      add(
//        dynamicFieldsValidator.add(
          Text(
            value = osoba.imieDrugie,
            label = "Drugie Imię"
          ).apply {
            onEvent {
              change = {
                osoba.imieDrugie = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
//            flabel.addCssClass("required-label")
          }//,
//          { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
//          POLE_WYMAGANE,
//          "doWiadomosci"
//        )
      )
      add(
        dynamicFieldsValidator.add(
          Text(
            value = osoba.nazwiskoCzlonPierwszy,
            label = "Nazwisko Pierwszy Człon"
          ).apply {
            onEvent {
              change = {
                osoba.nazwiskoCzlonPierwszy = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
            flabel.addCssClass("required-label")
          },
          { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
          POLE_WYMAGANE,
          "doWiadomosci"
        )
      )
      add(
//        dynamicFieldsValidator.add(
          Text(
            value = osoba.nazwiskoCzlonDrugi,
            label = "Nazwisko Drugi Człon"
          ).apply {
            onEvent {
              change = {
                osoba.nazwiskoCzlonDrugi = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
//            flabel.addCssClass("required-label")
          }//,
//          { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
//          POLE_WYMAGANE,
//          "doWiadomosci"
//        )
      )
      add(
//        dynamicFieldsValidator.add(
          Text(
            value = osoba.nazwiskoCzlonTrzeci,
            label = "Nazwisko Trzeci Człon"
          ).apply {
            onEvent {
              change = {
                osoba.nazwiskoCzlonTrzeci = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
//            flabel.addCssClass("required-label")
          }//,
//          { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
//          POLE_WYMAGANE,
//          "doWiadomosci"
//        )
      )
      add(createAddressElement(osoba.adres))
    }
  }

  private fun createAddressElement(adres: Adres): FieldsetPanel {
    return FieldsetPanel().apply {
      var polaAdresu = Div().apply {
        visible = adres.posiadaAdres
        lateinit var poleMiejscowosci: FormControl
        lateinit var polePoczty: FormControl
        lateinit var poleUlicy: FormControl
        add(
          dynamicFieldsValidator.add(
            Text(
              value = adres.kodPocztowy,
              label = "Kod Pocztowy"
            ).apply {
              onEvent {
                change = {
                  adres.kodPocztowy = self.value
                  Model.onEditPostalCodeRefresh(adres.kodPocztowy, polePoczty as TomTypeahead, poleMiejscowosci as TomTypeahead, poleUlicy as TomTypeahead)
                }
              }
              styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
              flabel.addCssClass("required-label")
            },
            { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
            POLE_WYMAGANE,
            "doWiadomosci"
          )
        )
        polePoczty = dynamicFieldsValidator.add(
          TomTypeahead(
            value = adres.poczta,
            label = "Poczta"
          ).apply {
            onEvent {
              change = {
                adres.poczta = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
            flabel.addCssClass("required-label")
          },
          { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
          POLE_WYMAGANE,
          "doWiadomosci"
        )
        add(polePoczty)
        poleMiejscowosci = dynamicFieldsValidator.add(
          TomTypeahead(
            value = adres.miejscowosc,
            label = "Miejscowość"
          ).apply {
            onEvent {
              change = {
                adres.miejscowosc = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
            flabel.addCssClass("required-label")
          },
          { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
          POLE_WYMAGANE,
          "doWiadomosci"
        )
        add(poleMiejscowosci)
        poleUlicy =
//          dynamicFieldsValidator.add(
          TomTypeahead(
            value = adres.ulica,
            label = "Ulica"
          ).apply {
            onEvent {
              change = {
                adres.ulica = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
//            flabel.addCssClass("required-label")
          }
//          ,
//          { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
//          POLE_WYMAGANE,
//          "doWiadomosci"
//        )
        add(poleUlicy)
        add(
          dynamicFieldsValidator.add(
            Text(
              value = adres.budynek,
              label = "Budynek"
            ).apply {
              onEvent {
                change = {
                  adres.budynek = self.value
                }
              }
              styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
              flabel.addCssClass("required-label")
            },
            { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
            POLE_WYMAGANE,
            "doWiadomosci"
          )
        )
        add(
//          dynamicFieldsValidator.add(
          Text(
            value = adres.lokal,
            label = "Lokal"
          ).apply {
            onEvent {
              change = {
                adres.lokal = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
//              flabel.addCssClass("required-label")
          }
//            ,
//            { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
//            POLE_WYMAGANE,
//            "doWiadomosci"
//          )
        )
      }
      add(
        CheckBox(value = adres.posiadaAdres, label = "Adres", rich = true)
          .apply {
            onEvent {
              change = {
                adres.posiadaAdres = self.value
                if (self.value) {
                  polaAdresu.show()
                } else {
                  polaAdresu.hide()
                }
              }
            }
          }
      )
      add(polaAdresu)
    }
  }

  private fun createButtonPanel(state: Formularz, reference: FormPanel<PodppForm>): Div {
  return (
      Div(className = "form-group my-3") {
        div(className = "row") {
          div(className = "col-lg-6") {
            div(className = "row") {
              div(className = "col-sm-6 py-2") {
                button(
                  "Zapisz dokument",
                  "far fa-save fa-3x d-block",
                  ButtonStyle.SUCCESS, className = "w-100"
                ).onClick {
                  val referenceData = state.form /*getReferenceData(reference, state)*/
                  val validateResult =
                    if (!(/*reference.validate() &&*/ dynamicFieldsValidator.validate()))
                      "Dokument zawiera niepoprawne dane." else null
                  referenceData?.let { it1 -> Model.zapisz(it1, validateResult) }
                }
              }
              div(className = "col-sm-6 py-2") {
                button("Sprawdź dokument", "fas fa-tasks fa-3x d-block", className = "w-100").onClick {
//                  val isValidatedStatic = reference.validate()
                  val isValidatedDynamic = dynamicFieldsValidator.validate()
                  if (/*isValidatedStatic &&*/ isValidatedDynamic) {
                    Alert.show(
                      "Sprawdzenie dokumentu",
                      "Dokument jest poprawny.<br/>Wszystkie pola wypełnione są prawidłowo.",
                      rich = true
                    )
                  } else {
                    Alert.show(
                      "Sprawdzenie dokumentu",
                      "Dokument zawiera niepoprawne dane.<br/>Należy poprawić pola oznaczone na czerwono.",
                      rich = true
                    )
                  }
                  Model.sprawdz()
                }
              }
            }
          }
          div(className = "col-lg-6") {
            div(className = "row") {
              div(className = "col-sm-6 py-2") {
                button("Podgląd dokumentu", "fas fa-eye fa-3x d-block", className = "w-100").onClick {
                  val referenceData = state.form /*getReferenceData(reference, state)*/
                  referenceData?.let { it1 -> Model.podglad(it1, this) }
                }
              }
              div(className = "col-sm-6 py-2") {
                button(
                  "Anuluj",
                  "fas fa-times fa-3x d-block",
                  ButtonStyle.SECONDARY, className = "w-100"
                ).onClick {
                  Confirm.show(
                    "Potwierdzenie",
                    "Czy anulować edycję formularza i powrócić do poprzedniej strony?",
                    yesTitle = "Tak",
                    noTitle = "Nie"
                  ) {
                    Model.anuluj()
                  }
                }
              }
            }
          }
        }
      }
    )
  }

}
